module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_PT-c24317030b297098381ddd5cc8f126c9.svg";